import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getTemplates, deleteTemplate, sendNotification } from 'actions/templateUpload'
import { hasAccess } from 'utils/hasAccess'
import { getConfig } from 'utils/config'

class CapitalLoanTemplateUpload extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    deleteTemplate: PropTypes.object.isRequired,
    getTemplates: PropTypes.object.isRequired,
    routes: PropTypes.instanceOf(Array),
    sendNotification: PropTypes.object.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    templateUpload: PropTypes.object.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Send capital loan documents', this.props.history, 'RW', true)
    this.props.getTemplates(getConfig().CAPITALLOAN_UPLOAD_LIBRARY, getConfig().CAPITALLOAN_UPLOAD_FOLDER)
    this.timer = setInterval(() => this.props.getTemplates(getConfig().CAPITALLOAN_UPLOAD_LIBRARY, getConfig().CAPITALLOAN_UPLOAD_FOLDER), 300000)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, templateUpload, currentUser,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText="Send capital loan pack" isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
              delTemplate={this.props.deleteTemplate}
              initTemplates={this.props.getTemplates}
              sendNotification={this.props.sendNotification}
              setErrorMessage={this.props.setErrorMessage}
              templateUpload={templateUpload}
            />
          ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  templateUpload: state.templateUpload,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getTemplates,
  deleteTemplate,
  sendNotification,
})(CapitalLoanTemplateUpload))



// WEBPACK FOOTER //
// ./src/containers/CapitalLoanTemplateUpload.js